module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens16-35f1f13fd0a0ec9e11961e72f52fe01d.jpg";